import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-WS-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 113.73 98.38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-WS-logo_svg__cls-2{fill:#00ac9d}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-WS-logo_svg__path4511",
      d: "M40.6 44.36 30.03 28.71s-4.75 5.32-5.81 6.47c-1.06 1.15-2.07 2-3.89 1.72-2.25-.33-12.1-2.36-12.1-2.36s-.78 12.15-.9 13.3a6.333 6.333 0 0 1-2.66 4.56l35.93-8.04Z",
      class: "svg-WS-logo_svg__cls-2"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-WS-logo_svg__path4513",
      d: "m80.73 35.37 12.5-22.71-10.89 4.73c-2.7 1.17-3.77 1-4.18-.91S75.82.79 75.69 0c-.78.79-14.44 14.65-16.33 16.48-1.89 1.83-3.26 2.08-4.95.91-1.69-1.17-6.92-4.69-6.92-4.69l-6.5 31.57 39.74-8.9Z",
      class: "svg-WS-logo_svg__cls-2"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      id: "svg-WS-logo_svg__path4515",
      d: "m103.82 47.84 9.91-13.3s-11.14 2-13.71 2.36c-2 .25-2.32-.54-2.41-1.72-.07-.6-.42-7.32-.42-7.32L81 35.69l-37.37 44 27.59 4.28s.09-4.22.2-7.35c.11-3.13 1.92-3.68 3-4.33 1.08-.65 32.53-18.86 32.53-18.86l-3.13-1.69c-1.92-1-.86-2.72 0-3.9",
      class: "svg-WS-logo_svg__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      id: "svg-WS-logo_svg__path4517",
      d: "m0 53.3 13.89 16.39c3.16 3.73 3.1 5.23-.13 9.19l-4.18 5.11 21-3.54c2.37-.4 4.73.26 4.15 3.51-.41 2.21-2.62 14.42-2.62 14.42l11-18.74 19.46-33.11-58.52 6.33L0 53.3Z",
      style: {"fill":"#00467f"}
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "WS-logo"}) } }